import * as req from 'api/actions';
import * as c from './constant';

export const getAppointmentsList = (payload, callback) =>
  req.list(
    c.GET_APPOINTMENTS_LIST,
    'api/v1/administrators/appointments',
    payload,
    callback
  );

export const showAppointment = (id, payload, callback) =>
  req.item(
    c.SHOW_APPOINTMENTS,
    `api/v1/administrators/appointments/${id}`,
    payload,
    callback
  );

export const createAppointments = (payload, callback) =>
  req.create(
    c.CREATE_APPOINTMENTS,
    'api/v1/administrators/appointments',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAppointments = (id, payload, callback) =>
  req.update(
    c.UPDATE_APPOINTMENTS,
    `api/v1/administrators/appointments/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const deleteAppointments = (id, payload, callback) =>
  req.remove(
    c.DELETE_APPOINTMENTS,
    `api/v1/administrators/appointments/${id}`, // url
    payload,
    callback
  );

export const getSystemModuleList = (payload, callback) =>
  req.list(
    c.GET_SYSTEM_MODULES,
    'api/v1/administrators/system_modules',
    payload,
    callback
  );
